<template>
  <div class="content-continer peview">
    
    <div class="right close-peview" @click="closePeview">关闭预览</div>
    <div class="right close-peview" @click="handleDown">导出PDF</div>
    <div classs="left close-peview" style="width:400px;margin-left:40px;">简历编号:{{personlist.resumeCode}}</div>

    <!-- 默认显示的预览界面 -->
    <ul style="margin-top:30px;margin-bottom: 100px;position: relative;" id="table">
      <li>
        <div class="left peview-img">
          <img :src="imgurl+personlist.workImgUrl" style="height:120px;" />
        </div>
        <div class="left">
          <p class="peview-name">{{personlist.cnName}}</p>
          <p class="peview-xq">
            <span>
              <img src="../assets/phone.png" />
              {{personlist.mobile}}
            </span>
            <span>
              <img src="../assets/old.png" />
              {{personlist.age}}岁
            </span>
            <span>
              <img src="../assets/address.png" />
              {{personlist.city}}
            </span>
          </p>
        </div>
        <div style="clear:both"></div>
      </li>
      <!-- 教育经历************************************************************************ -->
      <li>
        <div class="peview-list-title">教育经历</div>
        <ul>
          <li v-for="(item,index) in personlist.eduList">
            <div class="peview-list-title-name">{{item.schoolName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}-{{item.endDate}}</span>|
              <span>{{item.eduLevelDesc}}</span>|
              <span v-if="item.isGeneral==1">统招</span>
              <span v-if="item.isGeneral==0">自考</span>|
              <span>{{item.majorName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.eduList==''">
          <li>暂无数据</li>
        </ul>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 培训经历***************************************************************************** -->
      <li>
        <div class="peview-list-title">培训经历</div>
        <ul>
          <li v-for="(item,index) in personlist.trainList">
            <div class="peview-list-title-name">{{item.schoolName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}-{{item.endDate}}</span>|
              <span>{{item.courseName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.trainList==''">
          <li>暂无数据</li>
        </ul>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 获得证书************************************************************************************* -->
      <li>
        <div class="peview-list-title">获得证书</div>
        <ul>
          <li v-for="(item,index) in personlist.certificateList">
            <div class="peview-list-title-name">{{item.certificateName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.getTime}}</span>|
              <span>{{item.certificateName}}</span>
            </div>
          </li>
        </ul>
        <ul v-if="personlist.certificateList==''">
          <li>暂无数据</li>
        </ul>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
      </li>
      <!-- 项目经历******************************************************************************************* -->
      <li>
        <div class="peview-list-title">项目经历（个人备案）</div>
        <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        <ul>
          <li v-for="(item,index) in personlist.projectExpList0">
            <div class="peview-list-title-name">{{item.projectName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}-{{item.endDate}}</span>|
              <span>{{item.specialtyName}}</span>|
              <span>{{item.hospitalName}}</span>

            </div>
            <ul class="peview-item">
              <li>
                <p>公司名称</p>
                <p>{{item.smoName?item.smoName:'无'}}</p>
              </li>
              <li>
                <p>专业名称</p>
                <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
              </li>
              <li>
                <p>职位名称</p>
                <p>CRC</p>
              </li>
              <li>
                <p>项目类型</p>
                <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
              </li>
              <li>
                <p>证明人</p>
                <p>{{item.managerName?item.managerName:'无'}}</p>
              </li>
              <li>
                <p>证明人电话</p>
                <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
              </li>
              <li style="display:block;" v-if="item.workDesc">
                <p>项目描述</p>
                <p>{{item.workDesc}}</p>
              </li>
            </ul>
          </li>
        </ul>
        <ul v-if="personlist.projectExpList0==''">
          <li>暂无数据</li>
        </ul>
      </li>
      <li>
        <div class="peview-list-title">项目经历(公司备案)</div>
        <img src="../assets/geren-icon2.png" class="peview-b-icon" />
        <ul>
          <li v-for="(item,index) in personlist.projectExpList1">
            <img src="../assets/chapter.png" style="position: absolute;right: 110px;" />
            <div class="peview-list-title-name">{{item.projectName}}</div>
            <div class="peview-list-ed-msg">
              <span>{{item.startDate}}-{{item.endDate}}</span>|
              <span>{{item.specialtyName}}</span>|
              <span>{{item.hospitalName}}</span>
            </div>
            <ul class="peview-item">
              <li>
                <p>公司名称</p>
                <p>{{item.smoName?item.smoName:'无'}}</p>
              </li>
              <li>
                <p>专业名称</p>
                <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
              </li>
              <li>
                <p>职位名称</p>
                <p>CRC</p>
              </li>
              <li>
                <p>项目类型</p>
                <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
              </li>
              <li>
                <p>负责人</p>
                <p>{{item.managerName?item.managerName:'无'}}</p>
              </li>
              <li>
                <p>负责人电话</p>
                <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
              </li>
              <li style="display:block;" v-if="item.workDesc">
                <p>项目描述</p>
                <p>{{item.workDesc}}</p>
              </li>
            </ul>
          </li>
        </ul>
        <ul v-if="personlist.projectExpList1==''">
          <li>暂无数据</li>
        </ul>
      </li>
    </ul>

    <!-- 实际打印的界面 -->
    <ul style="margin-top:50px; margin-bottom: 100px;" id="demo">
      <div style="height: 1556px; background-color:#fff;">
        <!-- 头像和姓名等基本信息 -->
        <li>简历编号:{{personlist.resumeCode}}</li>
        <li>
          <div class="left peview-img">
            <img :src="imgurl+personlist2.workImgUrl" style="height:120px;" />
          </div>
          <div class="left">
            <p class="peview-name">{{personlist2.cnName}}</p>
            <p class="peview-xq">
              <span>
                <img src="../assets/phone.png" />
                {{personlist2.mobile}}
              </span>
              <span>
                <img src="../assets/old.png" />
                {{personlist2.age}}岁
              </span>
              <span>
                <img src="../assets/address.png" />
                {{personlist2.city}}
              </span>
            </p>
          </div>
          <div style="clear:both"></div>
        </li>
        <!-- 教育经历 -->
        <li style="height: 349px;">
          <div class="peview-list-title">教育经历</div>
          <ul>
            <li v-for="(item,index) in personlist2.eduList" :key="index">
              <div class="peview-list-title-name">{{item.schoolName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}-{{item.endDate}}</span>|
                <span>{{item.eduLevelDesc}}</span>|
                <span v-if="item.isGeneral==1">统招</span>
                <span v-if="item.isGeneral==0">自考</span>|
                <span>{{item.majorName}}</span>
              </div>
            </li>
          </ul>
          <ul v-if="personlist2.eduList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
        <!-- 培训经历 -->
        <li style="height: 511px;">
          <div class="peview-list-title">培训经历</div>
          <ul>
            <li v-for="(item,index) in personlist2.trainList" :key="index">
              <div class="peview-list-title-name">{{item.schoolName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}-{{item.endDate}}</span>|
                <span>{{item.courseName}}</span>
              </div>
            </li>
          </ul>
          <ul v-if="personlist2.trainList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
        <!-- 获得证书 -->
        <li style="height: 349px;">
          <div class="peview-list-title">获得证书</div>
          <ul>
            <li v-for="(item,index) in personlist2.certificateList" :key="index">
              <div class="peview-list-title-name">{{item.certificateName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.getTime}}</span>|
                <span>{{item.certificateName}}</span>
              </div>
            </li>
          </ul>
          <ul v-if="personlist2.certificateList==''">
            <li>暂无数据</li>
          </ul>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
        </li>
      </div>

      <!-- 项目经历 -->
      <!-- （1--1）个人备案 第一页最多显示 3 条数据，多余的数据分页显示-->
      <div style="height: 1556px; background-color:#fff;" v-if="personlist2.projectExpList0 !=''">
        <li>
          <div class="peview-list-title">项目经历（个人备案）</div>
          <img src="../assets/geren-icon1.png" class="peview-b-icon" />
          <ul>
            <li
              v-for="(item,index) in personlist2.projectExpList0"
              :key="index"
              style="padding-top: 20px;"
            >
              <div class="peview-list-title-name">{{item.projectName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}-{{item.endDate}}</span>|
                <span>{{item.specialtyName}}</span>|
                <span>{{item.hospitalName}}</span>

              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item.smoName?item.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>证明人</p>
                  <p>{{item.managerName?item.managerName:'无'}}</p>
                </li>
                <li>
                  <p>证明人电话</p>
                  <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
                </li>
                <li style="display:block; height: 157px; width: 988px; overflow: hidden;">
                  <p>项目描述</p>
                  <p>{{item.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
          <ul v-if="personlist2.projectExpList0==''">
            <li>暂无数据</li>
          </ul>
        </li>
      </div>

      <!-- (1--2) 个人备案  多余的数据的循环显示处理 -->
      <div
        v-show="selfMoreShow"
        style="height: 1556px; background-color:#fff;"
        v-for="(item,index) in selfMoreData"
        :key="index"
      >
        <li>
          <ul style="padding-top: 50px;">
            <li
              v-for="(item2,index2) in selfMoreData[index]"
              :key="index2"
              style="padding-top: 50px;"
            >
              <div class="peview-list-title-name">{{item2.projectName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item2.startDate}}-{{item2.endDate}}</span>|
                <span>{{item2.specialtyName}}</span>|
              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item2.smoName?item2.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item2.specialtyName?item2.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item2.phaseDesc?item2.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>证明人</p>
                  <p>{{item2.managerName?item2.managerName:'无'}}</p>
                </li>
                <li>
                  <p>证明人电话</p>
                  <p>{{item2.managerMobile?item2.managerMobile:'无'}}</p>
                </li>
                <li style="display:block; height: 157px; width: 988px; overflow: hidden;">
                  <p>项目描述</p>
                  <p>{{item2.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </div>

      <!-- （ 2--1）公司备案 第一页最多显示 3 条数据，多余的数据分页显示-->
      <div style="height: 1556px; background-color:#fff;" v-if="personlist2.projectExpList1 != ''">
        <li>
          <div class="peview-list-title">项目经历(公司备案)</div>
          <img src="../assets/geren-icon2.png" class="peview-b-icon" />
          <ul>
            <li
              v-for="(item,index) in personlist2.projectExpList1"
              :key="index"
              style="padding-top:20px;"
            >
              <img src="../assets/chapter.png" style="position: absolute;right: 110px;" />
              <div class="peview-list-title-name">{{item.projectName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item.startDate}}-{{item.endDate}}</span>|
                <span>{{item.specialtyName}}</span>|
                <span>{{item.hospitalName}}</span>
              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item.smoName?item.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item.specialtyName?item.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item.phaseDesc?item.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>负责人</p>
                  <p>{{item.managerName?item.managerName:'无'}}</p>
                </li>
                <li>
                  <p>负责人电话</p>
                  <p>{{item.managerMobile?item.managerMobile:'无'}}</p>
                </li>
                <li style="display:block; height: 157px; width: 988px; overflow: hidden;">
                  <p>项目描述</p>
                  <p>{{item.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
          <ul v-if="personlist2.projectExpList1==''">
            <li>暂无数据</li>
          </ul>
        </li>
      </div>

      <!-- (2--2) 公司备案  多余的数据的循环显示处理 -->
      <div
        style="height: 1556px; background-color:#fff;"
        v-for="(item,index) in companyMoreData"
        :key="index"
      >
        
        <li>
          <ul style="padding-top: 50px;">
            <li v-for="(item2,index2) in item" :key="index2" style="padding-top: 20px;">
              <img src="../assets/chapter.png" style="position: absolute;right: 110px;" />
              <div class="peview-list-title-name">{{item2.projectName}}</div>
              <div class="peview-list-ed-msg">
                <span>{{item2.startDate}}-{{item2.endDate}}</span>|
                <span>{{item2.specialtyName}}</span>
                <span>{{item2.specialtyName}}</span>
              </div>
              <ul class="peview-item">
                <li>
                  <p>公司名称</p>
                  <p>{{item2.smoName?item.smoName:'无'}}</p>
                </li>
                <li>
                  <p>专业名称</p>
                  <p>{{item2.specialtyName?item2.specialtyName:'无'}}</p>
                </li>
                <li>
                  <p>职位名称</p>
                  <p>CRC</p>
                </li>
                <li>
                  <p>项目类型</p>
                  <p>{{item2.phaseDesc?item2.phaseDesc:'无'}}</p>
                </li>
                <li>
                  <p>负责人</p>
                  <p>{{item2.managerName?item2.managerName:'无'}}</p>
                </li>
                <li>
                  <p>负责人电话</p>
                  <p>{{item2.managerMobile?item2.managerMobile:'无'}}</p>
                </li>
                <li style="display:block; height: 157px; width: 988px; overflow: hidden;">
                  <p>项目描述</p>
                  <p>{{item2.workDesc}}</p>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
import { preview } from "@/request/api";
import Watermark from "../js/watermark.js";
import Watermark2 from "../js/watermark2.js";
import htmlToPdf from "../js/htmlToPdf";
export default {
  data() {
    return {
      personlist: {},
      personlist2: {},
      imgurl: this.Common.imgurl,

      // 个人备案相关数据
      selfMoreData: "", //  个人备案多余数据的存储变量,默认为空
      selfMoreShow: false, //  个人备案多余页面是否显示,默认不显示

      // 公司备案的相关数据
      companyMoreData: "", //  公司备案多余数据的存储变量,默认为空
      companyMoreShow: false //  公司备案多余页面是否显示,默认不显示
    };
  },
  // 获取父元素传过来的ID值
  props: ["childid"],
  watch: {
    personlist2: function() {
       this.$nextTick(function() {
        Watermark2.set("临床CRC可信服务平台");
      });
    }
  },
  methods: {
    closePeview() {
      this.$emit("peviewstatus", false);
    },
    handleDown() {
      //导出PDF
      htmlToPdf.downloadPDF(document.querySelector("#demo"), "我的简历");
      
    }
  },
  mounted() {
    // alert(this.childid);
    preview(this.childid)
      .then(res => {
        // 预览展示的数据处理
        console.log(res.data.data);
        this.personlist = res.data.data;

        // 打印的数据处理
        this.personlist2 = res.data.data;

        // (1) 教育经历的数据限制 3 个
        if (this.personlist2.eduList.length > 3) {
          this.personlist2.eduList = this.personlist2.eduList.slice(0, 3);
         
          // this.personlist2.eduList = "";
        }

        // (2) 培训经历的数据限制 5个
        if (this.personlist2.trainList.length > 5) {
          this.personlist2.trainList = this.personlist2.trainList.slice(0, 5);
        }

        // (3) 获得证书的数据限制 3个
        if (this.personlist2.certificateList.length > 3) {
          this.personlist2.certificateList = this.personlist2.certificateList.slice(
            0,
            3
          );
        }

        // 个人备案数据的处理
        // --(1)-- 判断当前数据的长度是否超过 3 项
        if (this.personlist2.projectExpList0.length > 3) {
          // 超过 3 项
          // 多余的数据分组存储,便于循环渲染,每页显示 3 条数据

          // 判断多余数据可以分成几页
          let pageNum = Math.ceil(
            (this.personlist2.projectExpList0.length - 3) / 3
          );
          // 截取前 3 条数据
          let preThreeData = this.personlist2.projectExpList0.slice(0, 3);
          // 截取并且分组多余的所有数据
          let nextAllData = this.personlist2.projectExpList0.slice(
            3,
            this.personlist2.projectExpList0.length
          );

          this.selfMoreData = [];

          for (let i = 0; i < pageNum; i++) {
            if (i + 1 == pageNum) {
              this.selfMoreData[i] = nextAllData.slice(
                i * 3,
                nextAllData.length
              );
            } else {
              this.selfMoreData[i] = nextAllData.slice(i * 3, i * 3 + 3);
            }
          }
          // 设置前三项的数据重置
          this.personlist2.projectExpList0 = preThreeData;
          // 当前多余页面的状态设置为显示
          this.selfMoreShow = true;

          console.log("测试个人数据的本案的处理", this.selfMoreData);
          console.log(
            "测试个人数据的首三项的处理",
            this.personlist2.projectExpList0
          );
        } else {
          // 没有超过 3 项
          // 多余数据存储变量置空
          this.selfMoreData = [];
          // 当前多余页面状态设置为不显示
          this.selfMoreShow = false;
        }

        // 公司备案数据的处理( 同上, 个人备案数据处理, 不再注释说明)
        if (this.personlist2.projectExpList1.length > 3) {
          let pageNum = Math.ceil(
            (this.personlist2.projectExpList1.length - 3) / 3
          );
          let preThreeData = this.personlist2.projectExpList1.slice(0, 3);
          let nextAllData = this.personlist2.projectExpList1.slice(
            3,
            this.personlist2.projectExpList1.length
          );
          this.companyMoreData = [];
          for (let i = 0; i < pageNum; i++) {
            if (i + 1 == pageNum) {
              this.companyMoreData[i] = nextAllData.slice(
                i * 3,
                nextAllData.length
              );
            } else {
              this.companyMoreData[i] = nextAllData.slice(i * 3, i * 3 + 3);
            }
          }
          this.personlist2.projectExpList1 = preThreeData;
          this.companyMoreShow = true;
        } else {
          this.companyMoreData = [];
          this.companyMoreShow = false;
        }
        
        //  Watermark2.set("临床CRC可信服务平台");
      })
      .catch(err => {
        console.log(err);
      });
       
      
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.peview ul li li {
  margin-bottom: 20px;
}

.peview ul div li li {
  margin-bottom: 20px;
}
.peview-item li {
  display: block !important;
  float: left !important;
}
.peview-item {
  overflow: hidden !important;
}
#demo {
  position: absolute;
  width: 1100px;
  height: auto;
  left: -9999px;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/person/preview.vue